import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  href?: string;
  onClick?: () => void;
}
const pulseGlow = {
  animate: {
    scale: [1, 1.03, 1],
    boxShadow: ['0 0 0 0 rgba(212, 175, 55, 0.4)', '0 0 20px 8px rgba(212, 175, 55, 0.3)', '0 0 0 0 rgba(212, 175, 55, 0.0)']
  },
  transition: {
    duration: 2,
    repeat: Infinity,
    ease: 'easeInOut'
  }
};
export function Button({
  children,
  className = '',
  href = 'https://noveliahub.com/cart/44086900293668:1',
  onClick
}: ButtonProps) {
  return <motion.a href={href} onClick={() => {
    trackAddToCart();
    onClick?.();
  }} animate={pulseGlow.animate} transition={pulseGlow.transition} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.97
  }} className={`inline-block bg-gold hover:bg-gold-hover text-forest font-bold py-4 px-8 rounded-full shadow-lg transition-colors text-lg md:text-xl w-full md:w-auto text-center cursor-pointer ${className}`} data-id="element-47">
      {children}
    </motion.a>;
}